"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertArtifactExists = exports.artifactExists = void 0;
const artifacts_json_1 = __importDefault(require("../json/artifacts.json"));
const artifactExists = (nullifiers, commitments) => {
    const found = artifacts_json_1.default.find(artifact => artifact.nullifiers === nullifiers &&
        artifact.commitments === commitments);
    return found != null;
};
exports.artifactExists = artifactExists;
const artifactError = (nullifiers, commitments) => {
    return new Error(`No artifacts for inputs: ${nullifiers}-${commitments}`);
};
const assertArtifactExists = (nullifiers, commitments) => {
    if ((0, exports.artifactExists)(nullifiers, commitments)) {
        return;
    }
    throw artifactError(nullifiers, commitments);
};
exports.assertArtifactExists = assertArtifactExists;
